import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Typography, Box, Button, Hidden } from "@mui/material";
import clsx from "clsx";
import SettingsOption from "../SettingsOption";
import { UploadButton } from "../../../components/Buttons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  imageContainer: {
    backgroundColor: theme.palette.secondary[100],
    maxWidth: 647,
    maxHeight: 137
  },
  uploadButton: {
    cursor: "pointer",
    minWidth: "100%"
  }
}));

function BannerSettingsOption(props) {
  const {
    bannerImage,
    index,
    onBannerImageUpload,
    onBannerImageReset,
    onBannerImageDelete
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <SettingsOption>
      <Box
        flex={3}
        display={{ xs: "none", md: "flex" }}
        justifyContent="center"
      >
        <Typography
          noWrap
          variant="h5"
          className={clsx({
            disabled: !bannerImage.imgPath
          })}
        >
          {t("settings.bannerSettings.image", { image: index + 1 })}
        </Typography>
      </Box>
      <Box
        flex={10}
        mb={3}
        mt={{ xs: 0, md: 3 }}
        className={classes.imageContainer}
        height={{ xs: "20vw", sm: "17vw", md: "10vw" }}
      >
        {bannerImage.imgPath && (
          <img
            src={bannerImage.imgPath}
            alt={t("settings.bannerSettings.bannerImage") + " " + index}
            className={classes.image}
          />
        )}
      </Box>
      <Box
        display="flex"
        flex={{ xs: "unset", md: 4 }}
        pr={1.5}
        pl={2}
        alignItems="center"
        justifyContent="center"
      >
        <Hidden mdUp>
          <Box flex={1}>
            <Typography
              align="center"
              variant="h5"
              noWrap
              className={clsx({
                disabled: !bannerImage.imgPath
              })}
            >
              {t("settings.bannerSettings.image", { image: index + 1 })}
            </Typography>
          </Box>
        </Hidden>
        <Box display="flex" flexDirection="column" alignItems="center">
          <UploadButton
            acceptType="image/*"
            onUpload={e => onBannerImageUpload(e, index)}
            buttonId={`upload-image-${index}`}
            buttonText={
              bannerImage.imgPath
                ? t("settings.bannerSettings.changeImageBtn")
                : t("settings.bannerSettings.uploadImageBtn")
            }
          />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            width={{ xs: "auto", md: "100%" }}
            flex={1}
            pt={3}
          >
            {!bannerImage.default && (
              <Button
                variant="text"
                color="primary"
                onClick={() => onBannerImageReset(index)}
              >
                <Typography variant="button">
                  {t("settings.bannerSettings.resetBtn")}
                </Typography>
              </Button>
            )}
            {bannerImage.imgPath && (
              <Button
                variant="text"
                color="primary"
                onClick={e => onBannerImageDelete(e, index)}
              >
                <Typography variant="button">{t("deleteBtn")}</Typography>
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </SettingsOption>
  );
}

export default BannerSettingsOption;
